import { Component, EventEmitter, Output, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import Swal from "sweetalert2";
import { TranslateService } from '@ngx-translate/core';

//#region model
import { RequestModel } from 'src/app/Model/Request.model';
import { DocumentTrainingViewModel } from 'src/app/Model/DocumentTrainingViewModel.Model';
import { RequestStatusProcess } from 'src/app/Model/RequestStatusProcess';
import { ResponseData } from 'src/app/Model/Base/Response';

//#endregion model



//#region service
import { TrainingService } from 'src/app/Services/Training/Training.service';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';

import { StatusChangeByComponentView } from 'src/app/Model/StatusChangeByComponentView.model';
import { RequestService } from 'src/app/Services/request/request.service';
//#endregion service
@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.css']
})
export class TrainingComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  //#region variables
  public Request: RequestModel;
  public ConsultConnectionDocumentTraining: DocumentTrainingViewModel
  public requestcode: string;
  public redirectBool: boolean;
  private sendEmail: boolean = true;
  @Output() newRequestEvent = new EventEmitter<number>();
  @Output() nextEvent = new EventEmitter();

  public displayedColumns: string[] = ['DocumentNumber', 'DocumentName', 'DocumentFile', 'Status', 'Actions'];
  public ConnectionDocumentsTraining: DocumentTrainingViewModel[] = [];
  public dataSourceConsultConnectionDocumentTraining: MatTableDataSource<DocumentTrainingViewModel>;
  //#endregion variables

  constructor(public dialog: MatDialog,
    private readonly RequesStatus: RequesStatusService,
    private readonly ServiceTraining: TrainingService,
    private readonly translate: TranslateService,
    private readonly requestService: RequestService,
    private readonly router: Router,
    private readonly activeRoute: ActivatedRoute,
    private readonly spinner: NgxSpinnerService,  ) {
  }

  async ngOnInit() {
    if (this.activeRoute.snapshot.params.requestcode == undefined) {

      this.requestcode = sessionStorage.getItem('RequestCode')

    }
    else {

      this.requestcode = this.activeRoute.snapshot.params.requestcode

    }

    await this.GetRequestByCode(false)
    await this.checkTrainingStatus()
  }

  async checkTrainingStatus(){
      let documentsDownloadded = 0
      this.ConnectionDocumentsTraining.forEach(x => {
        if(x.Status)
        documentsDownloadded += 1
      });
      //revisar si todos los documentos ya fueron descargados
      if(this.ConnectionDocumentsTraining.length == documentsDownloadded){

        //revisar si el paso de entrenamiento se aprobó
        let trainingApproved = await this.ServiceTraining.getTrainingStatus(this.requestcode)
        if(trainingApproved != undefined && trainingApproved == false){
          //enviar la aprobación del paso
          this.Request = await this.requestService.getRequestByCode(this.requestcode);
          let newRequestStatus = new RequestStatusProcess
          newRequestStatus.IdRequest = this.Request.Id

          this.StatusChange(newRequestStatus);
        }
      }
        
  }

  redirectContinue() {

    this.router.navigate(['Register']);
  }

  public async DownloadFormat(id, url) {
    await this.ServiceTraining.InsertRegistry(id, this.requestcode).then((res1) => {
      window.open(url, '_blank','noopener,noreferrer')
      let documentsDownloadded = 0
      this.ConnectionDocumentsTraining.forEach(x => {
        if(x.Status)
        documentsDownloadded += 1
      });
      if(this.ConnectionDocumentsTraining.length == documentsDownloadded)
        this.sendEmail = false

      this.GetConnectionFileDocuments();
      if (res1.Approve && this.sendEmail) {
        this.StatusChange(res1);
      }
    });


  }

  public async GetRequestByCode(noMesaje) {
    if (this.requestcode == undefined) {
      Swal.fire({
        icon: "error",
        title: "No ha ingresado un radicado valido",
        showConfirmButton: false,
        timer: 3000,
      });
      this.redirectContinue()
    }

    await this.GetConnectionFileDocuments();


  }


  public async GetConnectionFileDocuments() {
    this.ConnectionDocumentsTraining = [];


    await this.ServiceTraining.getListDocumentsTraining(this.requestcode).then((res1) => {

      res1.forEach(
        (element) => {

          this.ConsultConnectionDocumentTraining = new DocumentTrainingViewModel
          this.ConsultConnectionDocumentTraining.DocumentNumber = element.Id;
          this.ConsultConnectionDocumentTraining.NameTraining = element.Training;
          this.ConsultConnectionDocumentTraining.DocumentName = element.NameFile;
          this.ConsultConnectionDocumentTraining.Status = element.Status;
          this.ConsultConnectionDocumentTraining.UrlDocumentFormat = element.UrlFile;


          this.ConnectionDocumentsTraining.push(this.ConsultConnectionDocumentTraining);



        });

      this.dataSourceConsultConnectionDocumentTraining = new MatTableDataSource(this.ConnectionDocumentsTraining);
      this.dataSourceConsultConnectionDocumentTraining.paginator = this.paginator;
      this.dataSourceConsultConnectionDocumentTraining.sort = this.sort;


    });
  }


  async StatusChange(itemrequest: RequestStatusProcess) {
    let res: ResponseData
    this.spinner.show()
    let StateChange = new StatusChangeByComponentView();
    StateChange.IdRequest=itemrequest.IdRequest;
    StateChange.Approve = true;
    StateChange.IdComponent = 23;
    StateChange.IdProfile = null;
    await this.RequesStatus.SetStatusByComponent(StateChange).then(resp => {
      res = resp;
    })
    this.spinner.hide();
    this.newRequestEvent.emit();
    if (res.head.status.toLowerCase() == 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      })
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: res.head.error.description,
        icon: 'error'
      }
      )
    }
  }


}
